import { useEffect, useState } from "react";
import { getUserDetailsView } from "../../api/users";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FiEdit, FiArrowLeft } from 'react-icons/fi';

const UserView = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState({});

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleEdit = () => {
        navigate('/users/edit', { state: { _id: state._id } });
    };

    const handlePrint = () => {
        // var prtContent = document.getElementById("print");
        // var WinPrint = window.open('', '', 'left=10,top=10,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        // WinPrint.document.write(prtContent.innerHTML);
        // WinPrint.document.close();
        // WinPrint.focus();
        // WinPrint.print();
        // WinPrint.close();
        window.print();
    }

    useEffect(() => {
        getUserDetailsView(state._id, setUserDetails, toast);
        // eslint-disable-next-line
    }, []);

    if (!userDetails) {
        return (
            <div className="main">
                <h1>Loading...</h1>
            </div>
        );
    }

    return (
        <div className="relative">
            <div className="bg-white m-5 rounded-md p-6 shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
                <div className="flex justify-between items-center mb-6">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center text-gray-600 hover:text-gray-800"
                    >
                        <FiArrowLeft className="mr-2" /> Back to Users
                    </button>
                    <button
                        onClick={handleEdit}
                        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        <FiEdit className="mr-2" /> Edit User
                    </button>
                </div>
            </div>



            <div className="bg-white rounded-lg shadow overflow-hidden">
                {/* Header */}
                <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
                    <h1 className="text-2xl font-semibold text-gray-800">User Details</h1>
                    <div className="flex items-center mt-2">
                        <span className={`px-2 py-1 text-xs rounded-full ${userDetails.status === 'active' ? 'bg-green-100 text-green-800' :
                                userDetails.status === 'inactive' ? 'bg-yellow-100 text-yellow-800' :
                                    'bg-red-100 text-red-800'
                            }`}>
                            {userDetails.status?.charAt(0).toUpperCase() + userDetails.status?.slice(1) || 'N/A'}
                        </span>
                        <span className="ml-2 text-sm text-gray-500">
                            User ID: {userDetails.userId || 'N/A'}
                        </span>
                    </div>
                </div>

                {/* Main Content */}
                <div className="p-6">
                    {/* Personal Details */}
                    <div className="mb-8">
                        <h2 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">Personal Information</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-4">
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Full Name</h3>
                                    <p className="mt-1 text-sm text-gray-900">
                                        {userDetails.firstName} {userDetails.lastName}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Username</h3>
                                    <p className="mt-1 text-sm text-gray-900">{userDetails.username || 'N/A'}</p>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Email</h3>
                                    <p className="mt-1 text-sm text-gray-900">{userDetails.email || 'N/A'}</p>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Mobile</h3>
                                    <p className="mt-1 text-sm text-gray-900">{userDetails.mobile || 'N/A'}</p>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Gender</h3>
                                    <p className="mt-1 text-sm text-gray-900 capitalize">
                                        {userDetails.gender || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Age Group</h3>
                                    <p className="mt-1 text-sm text-gray-900">
                                        {userDetails.ageGroup?.replace('_', '-') || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Member Since</h3>
                                    <p className="mt-1 text-sm text-gray-900">
                                        {formatDate(userDetails.createdAt)}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-500">Last Updated</h3>
                                    <p className="mt-1 text-sm text-gray-900">
                                        {formatDate(userDetails.updatedAt)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Affiliation Details */}
                    <div className="mb-8">
                        <h2 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">Affiliation Details</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Affiliation Code</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.affiliationCode || 'N/A'}</p>
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Affiliated By</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.affiliatedBy || 'N/A'}</p>
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Referral Code</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.referralCode || 'N/A'}</p>
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Referred By</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.referredBy?.username || 'N/A'}</p>
                            </div>
                        </div>
                    </div>

                    {/* Location Details */}
                    <div className="mb-8">
                        <h2 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">Location Details</h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Country</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.country || 'N/A'}</p>
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">State</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.state || 'N/A'}</p>
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">City</h3>
                                <p className="mt-1 text-sm text-gray-900">{userDetails.city || 'N/A'}</p>
                            </div>
                        </div>
                    </div>

                    {/* Social Media */}
                    <div className="mb-8">
                        <h2 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">Social Media</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {['linkedIn', 'facebook', 'instagram', 'twitter'].map((platform) => (
                                <div key={platform}>
                                    <h3 className="text-sm font-medium text-gray-500 capitalize">
                                        {platform === 'linkedIn' ? 'LinkedIn' : platform}
                                    </h3>
                                    <p className="mt-1 text-sm text-blue-600 hover:underline">
                                        {userDetails[platform] ? (
                                            <a href={userDetails[platform]} target="_blank" rel="noopener noreferrer">
                                                {userDetails[platform].length > 40
                                                    ? `${userDetails[platform].substring(0, 40)}...`
                                                    : userDetails[platform]}
                                            </a>
                                        ) : 'N/A'}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Impact Details */}
                    <div className="mb-8">
                        <h2 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">Impact Details</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Challenges Completed</h3>
                                <p className="mt-1 text-sm text-gray-900">
                                    {userDetails.challengesParticipated?.length || 0}
                                </p>
                            </div>
                            <div>
                                <h3 className="text-sm font-medium text-gray-500">Total Points</h3>
                                <p className="mt-1 text-sm text-gray-900">
                                    {userDetails.points || 0}
                                </p>
                            </div>
                            {userDetails.ambassadorDetails && userDetails.ambassadorDetails.isInfluencer && (
                                <>
                                    <div>
                                        <h3 className="text-sm font-medium text-gray-500">Message Likes</h3>
                                        <p className="mt-1 text-sm text-gray-900">
                                            {userDetails.ambassadorDetails.messageLikesCount || userDetails.ambassadorDetails.messageLikes?.length || 0}
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="text-sm font-medium text-gray-500">Message Comments</h3>
                                        <p className="mt-1 text-sm text-gray-900">
                                            {userDetails.ambassadorDetails.messageCommentsCount || userDetails.ambassadorDetails.messageComments?.length || 0}
                                        </p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Audit Trail */}
                    {userDetails.auditTrail && (
                        <div className="mb-8">
                            <h2 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">Audit Trail</h2>
                            <div className="bg-gray-50 p-4 rounded-md">
                                <p className="text-sm text-gray-700 whitespace-pre-line">
                                    {userDetails.auditTrail}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
                <div className="mt-6 flex justify-between items-center">
                    <div className="flex flex-col space-y-4">
                        <div className="flex items-center gap-2">
                            <span className="font-bold capitalize">Challenges Suggested:</span>
                            <span className="text-stone-500">{userDetails.challengesCreated?.length || 0}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-bold capitalize">Badges:</span>
                            <span className="text-stone-500">{userDetails.badges?.length || 0}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-bold capitalize">Events Volunteered:</span>
                            <span className="text-stone-500">{userDetails.events?.length || 0}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-bold capitalize">Friends Added:</span>
                            <span className="text-stone-500">0</span>
                        </div>
                    </div>

                    <div className="flex flex-col items-end space-y-4">
                        <img
                            src={userDetails.profilepic || 'https://via.placeholder.com/150'}
                            alt="user"
                            className="border w-32 h-40 rounded-md object-cover"
                        />
                        <button
                            className="bg-primary text-white text-lg font-bold px-6 py-2 rounded-md hover:bg-opacity-90 transition-colors"
                            onClick={handlePrint}
                        >
                            Print
                        </button>
                    </div>
                </div>
            </div>
            <ToastContainer position="bottom-right" />
        </div>
    );
};

export default UserView;